































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import jQuery from 'jquery';

import Brand from '@/services/Brand';
import Staff, { Approval } from '@/services/Staff';
import * as Sentry from '@sentry/browser';

import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';

import Modal from '../Base.vue';

@Component({
	name: 'ReportsApprovalMmic',
	components: {
		Alert,
		Loading,
		Modal,
		TextField,
	},
})
export default class ReportsApprovalMmic extends Vue {
	@Prop(String) private id: string;
	@Prop() private approval: any;
	@Prop() private approvals: any;
	@Prop() private policyApproved: boolean | string;
	@Prop() private policyDenied: boolean | string;

	@State('user', { namespace: 'Auth' }) private user;

	private error: boolean | string = false;
	private success: boolean | string = false;
	private policyError: boolean | string = false;
	private denialReason: string = '';

	private created(): void {
		this.watchApproval();
	}

	private close(): void {
		this.$emit('update:approvals', this.approvals);
		jQuery(`#${this.id}`).modal('hide');
	}

	private watchApproval(): void {
		this.approval.policy_numbers.forEach(policy => {
			if (!(policy.policy_number && (policy.client_id || policy.new_client_id))) {
				this.error = true;
			} else {
				this.error = false;
			}
		});
	}

	private async approve(): Promise<void> {
		try {
			await Staff.sendApproval(true, this.approval.sub, 'REPORTS');
			this.policyApproved = true;
			this.filterOutApproval(this.approval);
		} catch (e) {
			Sentry.captureException(e);
			this.error = e.data.error;
		}
	}

	private async deny(): Promise<void> {
		try {
			await Staff.sendApproval(false, this.approval.sub, 'REPORTS', false, this.denialReason);
			this.policyDenied = true;
			this.filterOutApproval(this.approval);
		} catch (e) {
			Sentry.captureException(e);
			this.error = e.data.error;
		}
	}

	private filterOutApproval(approval: Approval): void {
		this.approvals = this.approvals.filter((item: Approval): boolean => item !== approval);
	}

	private async updatePolicy(policy): Promise<void> {
		const sendData = {
			cmd: 'new_policy' as const,
			policy: {
				policy_number: policy.policy_number,
				client_id: policy.new_client_id,
				brand: Brand.getBrand(),
			},
			org_id: this.user.org_id,
			sub: this.approval.sub,
		};

		this.policyError = false;

		try {
			const updateData = await Staff.updateUser(sendData);

			if ('error' in updateData.data) {
				this.policyError = updateData.data.error;
				return;
			}
			const deleteData = {
				cmd: 'delete_policy' as const,
				policy: {
					policy_number: policy.policy_number,
					client_id: null,
					brand: Brand.getBrand(),
				},
				sub: this.approval.sub,
			};
			const deletePolicy = await Staff.updateUser(deleteData);
			this.success = 'Policy Updated';
			this.watchApproval();
		} catch (e) {
			Sentry.captureException(e);
			this.success = false;
			this.policyError = 'There was an error updating your policy.';
		}
	}
}
